export default {
  forgot_password: {
    title: 'รีเซ็ตรหัสผ่าน',
    required: '@:validation.required',
    incorrect_email_address: '@:validation.email_format',
    double_check_text: '@:login.double_check_text',
    forgot_password: 'ลืมรหัสผ่าน',
    password_reset_text: 'พิมพ์ที่อยู่อีเมลของคุณ คุณจะได้รับอีเมลยืนยันเพื่อรีเซ็ตรหัสผ่านของคุณ',
    submit: 'ส่ง',
    mail_address: 'กรอกที่อยู่อีเมล',
    input_label: '@:settings.user.email',
  },
}
